// extracted by mini-css-extract-plugin
export default {"container_VideoSection":"VideoBG_container_VideoSection__xspgq","grain":"VideoBG_grain__x4EgG","VideoBg":"VideoBG_VideoBg__mR61w"};